// Multiple Products Message (MPM) template preview helpers.
// mpmSections/mpmThumbnail may arrive as JSON strings (as stored by the
// backend) or already-parsed objects depending on the source, so every
// consumer needs to handle both.

const parseMaybeJson = (value) => {
  if (!value) return null;
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const getMpmProductCount = (mpmSections) => {
  const sections = parseMaybeJson(mpmSections);
  if (!Array.isArray(sections)) return 0;
  return sections.reduce(
    (count, section) => count + (section?.products?.length || 0),
    0,
  );
};

// Also used for SPM: spmProduct is stored in the same {title, retailerId, imageUrl} shape
export const getMpmThumbnailImage = (mpmThumbnail) => {
  const thumbnail = parseMaybeJson(mpmThumbnail);
  return thumbnail?.imageUrl || undefined;
};

export const getSpmProductName = (spmProduct) => {
  const product = parseMaybeJson(spmProduct);
  return product?.title || undefined;
};
